import { render, staticRenderFns } from "./CardArticles.vue?vue&type=template&id=0e08bd03&"
import script from "./CardArticles.vue?vue&type=script&lang=ts&"
export * from "./CardArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports